import script from "./CalibrateModules.vue?vue&type=script&setup=true&lang=ts"
export * from "./CalibrateModules.vue?vue&type=script&setup=true&lang=ts"

import "./CalibrateModules.vue?vue&type=style&index=0&id=0fa2934c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0fa2934c"]])

export default __exports__